import { useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

export default function useFileProcessor() {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
  const { t, i18n: { language } } = useTranslation("global");  

  const urlEndpointImgProcessor = 'https://mamografia-analisis-service-back-54644131242.us-central1.run.app/analyze';

  const uploadFileProcessor = async (docData, msg, type) => {
    setLoading(true);
    // return new Promise(function(resolve, reject) {
    //   const xhr = new XMLHttpRequest();
    //   const fd = new FormData();
    //   xhr.open('POST', urlEndpoint, true);
    //   // xhr.setRequestHeader('Content-Type', 'multipart/form-data');
    //   xhr.setRequestHeader('ACTION_SECRET', 'Nhk03CBnel');
    //   xhr.onreadystatechange = () => {
    //     if(xhr.readyState === 4) {
    //       if(xhr.status === 200) {
    //         const response = JSON.parse(xhr.responseText);
    //         setData(response);
    //         resolve(response);
    //       } else {
    //         const errorMessage = xhr.status + ' Error uploading the archive';
    //         setError(errorMessage);
    //         reject(errorMessage);
    //       }
    //       setLoading(false);
    //     }
    //   };
    //   fd.append('file', docData);
    //   xhr.send(fd);
    // });

    const fd = new FormData();
    docData.forEach((file) => {
      fd.append('files', file);
    });
    fd.append('analysis_type', type);
    fd.append('doctor_message', msg);

    // const accessToken = await getTokenInfo();    

    let customHeaders = {
      'accept-Language': language.split('-')[0]
    }
    
    // if(bucket) {
    //   customHeaders = {
    //     'BUCKET_NAME': bucket.toString(),
    //     "Authorization": `Bearer ${accessToken.token}`,
    //     'Content-Type': 'multipart/form-data'
    //   }
    // }    

    return new Promise(function(resolve, reject) {
      axios.post(urlEndpointImgProcessor.toString(), fd, {
          headers: customHeaders
      })
      .then(response => { 
        setLoading(false);
        setData(response);
        resolve(response);
      })
      .catch(error => {   
        setLoading(false);
        setError(error);
        reject(error);
      });
    })
  }

  const cleanAction = () => {
    setData(null);
    setLoading(false);
    setError(null);
  } 
  
  return {
    uploadFileProcessor,
    data,
    loading,
    error,
    cleanAction
  }
}